export function debugLog(...data: Parameters<typeof console.log>) {
  if (process.env.LOG_LEVEL === "debug") {
    console.log(...data)
  }
}
